import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar.jsx";
import Home from "./components/Home.jsx";
import Footer from "./components/Footer.jsx";
import AboutPage from "./pages/AboutPage.jsx";
import ServiceDetail from "./pages/ServiceDetail.jsx";
import Products from "./pages/Products.jsx";
import CompanyPage from "./pages/OurCompany.jsx";

import ERPProductPage from "./pages/products/Erp.js";
import CRMPage from "./pages/products/Crm.js";
import HRMPage from "./pages/products/Hrm.js";

import WebDevelopmentPage from "./pages/services/web.js";
import MobileAppPage from "./pages/services/App.js";
import EcommercePage from "./pages/services/Ecommerce.js";
import CloudPage from "./pages/services/cloud.js";
import TranscriptionPage from "./pages/services/Transcription.js";
import AudioVoicePage from "./pages/services/Audio-voice.js";
import NLPLLMDatasetServices from "./pages/services/NLPLLMDatasetServices.js";
import ImagePhotoPage from "./pages/services/Image-Photo.js";
import VideoDatasetServices from "./pages/services/VideoDatasetServices.js";
import ImageAnnotationPage from "./pages/services/TwoDThreeDService.js";
import AiTrainingData from "./pages/services/AITraining.js";
import CategorizingTagging from "./pages/services/CategorizingAndTagging.js";
import PhoneticTranscription from "./pages/services/phoneticTranscription.js";
import TwoDThreeDService from "./pages/services/TwoDThreeDService.js";
import BillingInvoicingPage from "./pages/products/BillingInvoicingPage.js";
import CareersPage from "./components/CareersPage.jsx";
import ContactPage from "./components/Contact.jsx";
import AdminContacts from "./components/AdminContacts.jsx";

export default function App() {
  const { pathname } = useLocation();

  // 🔽 Scroll to top on route change
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [pathname]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      //   behavior: "smooth",
      behavior: "auto",
    });
  }, [pathname]);

  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServiceDetail />} />
        <Route path="/products" element={<Products />} />
        <Route path="/company" element={<CompanyPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin/contacts" element={<AdminContacts />} />
        
        <Route path="/erp" element={<ERPProductPage />} />
        <Route path="/crm" element={<CRMPage />} />
        <Route path="/hrm" element={<HRMPage />} />
        <Route path="/billing" element={<BillingInvoicingPage />} />

        <Route path="/services/web" element={<WebDevelopmentPage />} />
        <Route path="/services/mobile" element={<MobileAppPage />} />
        <Route path="/services/ecommerce" element={<EcommercePage />} />
        <Route path="/services/cloud" element={<CloudPage />} />
        <Route path="/services/transcription" element={<TranscriptionPage />} />
        <Route path="/services/audio-voice" element={<AudioVoicePage />} />
        <Route path="/services/nlp-llm" element={<NLPLLMDatasetServices />} />
        <Route path="/services/image-photo" element={<ImagePhotoPage />} />
        <Route path="/services/video" element={<VideoDatasetServices />} />
        <Route path="/services/2d3d" element={<TwoDThreeDService />} />
        <Route path="/services/ai-training" element={<AiTrainingData />} />
        <Route
          path="/services/categorizing-tagging"
          element={<CategorizingTagging />}
        />

        <Route
          path="/services/phonetic-transcription"
          element={<PhoneticTranscription />}
        />
      </Routes>

      <Footer />
    </>
  );
}
